<div class="AMCarryOnOfferModal bg-am-medium-blue text-am-white">
  <div class="AMCarryOnOfferModal-header">
    <img src="assets/images/close.svg" alt="close" (click)="onClose()">
  </div>
  <div class="AMCarryOnOfferModal-content">
    <div class="content-title">
      <img src="./assets/images/bags/modals/carryon-offer-modal.svg" alt="boardin passes" class="size-img" *ngIf="typeModal=='offer'">
      <p class="title">{{ tittle | translate }}</p>
    </div>

    <!-- type offer  -->

    <p *ngIf="typeModal=='offer' && countIncludes === 1" class="subTitle">{{ 'carryonOfferModal.subTitleOffer' | translate }}</p>
    <p *ngIf="typeModal=='offer' && countIncludes === 2" class="subTitle">{{ 'carryonOfferModal.subTitleOffer2' | translate }}</p>
    <div class="content-information" *ngIf="typeModal=='offer'">
      <p class="title">{{ 'carryonOfferModal.titlePriceBags' | translate }}</p>
      <div class="content-passengers">
        <div class="name-passenger" *ngFor="let item of offer">
          <span>{{ item.bagNumber | translate}}</span>
          <span>$ {{ item.total }} {{ item.currencyCode }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="typeModal=='bag'" class="content-bags">
      <div class="item-bag">
        <img src="./assets/images/bags/baggage-size-carryon.svg" alt="">
        <div class="item-title-bag">
          <span class="fs-20px lh-24px fw-medium-x">{{'carryonOfferModal.itemBagCarryOn.title' | translate }}</span>
          <span class="fs-16px lh-24px fw-regular">{{'carryonOfferModal.itemBagCarryOn.description' | translate }}</span>
        </div>
      </div>
      <div class="item-bag">
        <img src="./assets/images/bags/baggage-size-25.svg" alt="">
        <div class="item-title-bag">
          <span class="fs-20px lh-24px fw-medium-x">{{'carryonOfferModal.itemBagBasic.title' | translate}}</span>
          <span class="fs-16px lh-24px fw-regular">{{'carryonOfferModal.itemBagBasic.description' | translate }}</span>
        </div>
      </div>
    </div>

  </div>
</div>
